import { PlanningPage } from "@onesolution/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/_layout/planning")({
	component: PlanningPage,
});
